{
	"update-info": {
		"forced": {
			"message": "Obecna wersja nie jest już obsługiwana. \nPrzejdź do sklepu z aplikacjami i zaktualizuj ją do najnowszej wersji.",
			"title": "Uprzejmie prosimy o aktualizację aplikacji"
		},
		"optional": {
			"title": "Dostępna nowa wersja!",
			"message": "Zaktualizuj do najnowszej wersji, gdy będziesz gotowy, aby cieszyć się najnowszymi funkcjami."
		},
		"whats-new": "Co nowego?",
		"update-now": "Zaktualizuj teraz",
		"maybe-later": "Może później",
		"version": "Wersja"
	}
}
